import React from 'react';
import AdminHeader from './AdminHeader';

const AdminLayout = ({ children }) => {
  return (
    <AdminHeader>
      {children}
    </AdminHeader>
  );
};

export default AdminLayout; 